export const PRIVACY_INTRO = [
  "This privacy policy would explain how we will collect, process, use, share, and protect the information that you share. It will also tell how you can access and update the information and make choices about the same.",
  "This privacy policy would cover online (website, mobile application) and offline (data collected through telephone, mailings, or in person) activities provided, operated, or owned by the Company. These \"online\" and \"offline\" activities are related to the facilitation of taxi hire services through taxi operators and third-party drivers, which we will refer to as the \"Services.\"",
  "The Privacy policy would also apply to your using interactive features or downloads that we own or control, are available through services, and interact with the services.",
  "By Accepting The Customer Terms And Conditions, You Agree To The Terms Of This Privacy Policy.",
  "If you have any questions about the Privacy Policy, you can contact us through the email address on the website or through the Mobile application.",
];

export const PRIVACY_SECTIONS = [
  {
    id: "information-you-provide",
    title: "Information You Provide To Us",
    paragraphs: [
      "We will ask you to provide us with specific protected data. This information we will collect through modes like account registration forms, contact us forms, or any other forms. When you sign up on the app, you will have to create a user profile. The data that we will ask for will include the following:",
    ],
    listItems: ["Full name", "Email", "Password", "Address", "Mobile phone Number", "Pin code"],
  },
  {
    id: "information-access-use",
    title: "Information We Collect As You Access And Use Our Services",
    paragraphs: [
      "In addition to this information, we would use technologies that would collect data whenever you visit or interact with the Services. This could include your Browser, the URL you used to reach our services, areas of services you accessed, time of day, etc. We will also find the Device Identifier, which is a number that is assigned to the device you are using. In case of booking via the call center, Ola may record calls and chat histories for quality and training purposes.",
      "If you book a vehicle through our platform, we will also collect the following details:",
      "We will collect usage information through Cookies. If you don't want that information to be shared, you can deny the use of cookies. However, if you choose to do so, some features of the service may not be available.",
    ],
    listItems: [
      "Tracking information as you use our services",
      "Details of emergency contact name and phone number",
      "Number of friends that you refer to our app",
      "Contact information of any other person for whom you booked the ride",
    ],
  },
  {
    id: "mobile-applications",
    title: "Information Collected By Mobile Applications",
    paragraphs: [
      "When you use your Mobile application, it may automatically collect the following information:",
    ],
    listItems: [
      "Your preferred language",
      "Country site",
      "The manufacturer and model of your mobile device",
      "Your mobile operating system",
      "The type of mobile internet browsers you are using",
      "Your geolocation",
      "Information about how you interact with the mobile application and the duration",
      "Data from the SMS/ text messages for issuing OTP, filling information during financial transactions, etc.",
    ],
  },
  {
    id: "disclose-third-parties",
    title: "How And When Do We Disclose Information To Third Parties",
    paragraphs: [
      "We will not sell, share or trade any information that we have received about you other than what we are disclosing in this Privacy Policy. These are the instances when you might get contacted by third parties.",
    ],
    listItems: [
      "If you agree to have your information shared but this will be subject to the Privacy policy terms.",
      "To those who are facilitating our services, like drivers and companies they are working for.",
      "Third parties that track services analytics, process payments, and engage in anti-fraud or security measures.",
      "Those who provide customer support, geolocation information, perform technical services, etc.",
    ],
  },
  {
    id: "contests-promotions",
    title: "Contests And Promotions",
    paragraphs: [
      "We may offer promotions that would need registrations. When you participate in the promotion, you agree to the rules that govern that promotion. This includes allowing the sponsor of the promotion to use your name, voice, etc., in the advertising and marketing of the promotion. By entering the promotion, you agree that the information be disclosed to third parties to help in the administration of the promotion. This includes prize fulfillment, winner selection, etc.",
    ],
  },
  {
    id: "business-transfer",
    title: "Business Transfer",
    paragraphs: [
      "We may share your data with our parent, subsidiaries, and affiliates for internal reasons or business and promotional purposes. We will also reserve the right to transfer and disclosing of the information to the following:",
    ],
    listItems: [
      "To an owner, co-owner, or operator of Services or database",
      "In relation to a corporate merger, restructuring, consolidation, sale of membership interests or assets, or any other corporate range",
    ],
  },
  {
    id: "market-study",
    title: "Market Study And Other Benefits",
    paragraphs: [
      "We may share the data with third parties that may include market research/study, conduct data analysis, find out and customize product or service offerings, improve products and services, make any other product available to you, etc.",
    ],
  },
  {
    id: "third-party-content",
    title: "Third-party Content And Links To Third-party Services",
    paragraphs: [
      "The services could contain content supplied by a third party. These third parties may contain website usage information and the Device Identifier. Also, during the use of services, you may be directed to other sites and applications that could be controlled by them. We will have no say in that matter.",
      "We will not be responsible for the privacy practices that these third parties use. These parties may send their own cookies, collect data or solicit your protected information. They may not even have their own published privacy policies. We would advise that when you leave our services, you must read the Privacy policies of these third-party websites or applications.",
    ],
  },
  {
    id: "social-media",
    title: "Social Media Features And Widgets",
    paragraphs: [
      "The online and mobile services may also include social media features like the Facebook Like button or the \"Share This\" button. They may also include interactive mini-programs that run on online and mobile services. The features could collect IP addresses, photographs, and pages you are visiting and set a cookie to ensure the feature works properly. All these features would come under the Privacy policy set by the providers.",
    ],
  },
  {
    id: "drivers",
    title: "Information Collected By Drivers",
    paragraphs: [
      "This Privacy Policy will not cover the use of information that is obtained by the driver or his Company. This could be while providing you a ride on a cab booked using our services or not provided by us.",
    ],
  },
  {
    id: "change-account",
    title: "Change Of Information And Cancellation Of Account",
    paragraphs: [
      "You are liable to maintain the accuracy of the data you submit to us. If your protected information has changed or you do not need our services, you could correct, or remove the mistakes, change the information by going to our member information page, or you could contact us through the email address mentioned on the website or mobile application.",
      "You could also cancel or change the communications that you chose to receive from the services. This you can do by following the instructions mentioned in the email. Or you could log into your user account and change the communication preferences.",
      "If you want to cancel your account, you can contact us through the email address that is mentioned on the trip bill received. We retain your protected information only until your account with our Services is active. After your account is canceled, we will still retain the Protected and Usage information for the following purposes:",
    ],
    listItems: [
      "Legal and regulatory obligations",
      "Resolving disputes",
      "Complete activities related to cancellation",
      "Investigate any fraud or inappropriate activity",
      "Enforce the agreements",
      "Data analysis",
    ],
  },
  {
    id: "security",
    title: "Security",
    paragraphs: [
      "The Protected information and usage information we have collected will be securely stored within our database. We use reasonable security practices like encryption, firewalls, and SSL to protect the information. However, no security system is impenetrable. We will not be able to guarantee the security of the databases and promise that your information will remain absolutely safe. It is advisable that you do not share your password with anyone.",
    ],
  },
  {
    id: "grievance",
    title: "Grievance Officer",
    paragraphs: [
      "We appoint our support manager as the grievance officer, and he can be contacted through the email address on the website or mobile application.",
    ],
  },
  {
    id: "changes",
    title: "Changes To The Privacy Policy",
    paragraphs: [
      "With time we might update the Privacy Policy to show the changes to the information services. The changes made will be effective once we post the revised Privacy Policy.",
    ],
  },
];
